import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    auctionType,
    bidType,
} from '../../types';
import {
    ENERGY,
    getProductType,
    SECURITY,
} from '../../utils/ProductTypes';
import { onActionKey } from '../../utils';
import ReadonlyField from '../fields/ReadonlyField';
import { getBidCancellationReason } from '../../utils/BidCancellationReasons';
import { createUserValue } from '../../utils/bids';
import Number from '../Number';

AutomaticallyCancelledBidRow.propTypes = {
    auction: auctionType.isRequired,
    bid: bidType.isRequired,
};

function AutomaticallyCancelledBidRow(props) {
    const {
        auction,
        bid,
    } = props;
    const { t } = useTranslation();
    const productType = getProductType(auction.product.productType);
    const [isExpanded, setExpanded] = useState(false);
    const toggleExpansion = () => setExpanded(!isExpanded);
    let complementRowColSpan = 5;
    if (productType.is(ENERGY)) {
        complementRowColSpan += 1;
    }
    return (
        <>
            <tr className="bid-row">
                <td className="bid-row--user--container readonly">
                    <div className="bid-row--toggler" onClick={toggleExpansion} onKeyUp={onActionKey(toggleExpansion)} role="button" tabIndex={-1}>
                        <div className="bid-row--arrow">
                            <FontAwesomeIcon icon={`caret-${isExpanded ? 'down' : 'right'}`} />
                        </div>
                        {createUserValue(bid)}
                    </div>
                </td>
                {productType.is(ENERGY) && (
                    <td className="bid-row--balancing-group--container readonly">{bid.member.balancingGroup}</td>
                )}
                <td className="bid-row--member--container readonly">{bid.member.memberId}</td>
                <td className="bid-row--quantity--container readonly"><Number value={bid.quantity} /></td>
                <td className="bid-row--price--container readonly"><Number value={bid.price} fractionDigits={2} /></td>
                <td className="bid-row--cancellation-reason--container readonly">{getBidCancellationReason(bid.cancellationReason).translate(t)}</td>
            </tr>
            <tr className={`bid-row-complement${isExpanded ? ' expanded' : ''}`}>
                <td colSpan={complementRowColSpan}>
                    <div className="bid-row-complement--container">
                        <ReadonlyField
                            label={t('auctions.bids-list.bid-row.id')}
                            value={bid.id}
                            className="bid-row-complement--id"
                        />
                        <ReadonlyField
                            label={t('auctions.bids-list.bid-row.creation-time')}
                            value={bid.creationTime}
                            className="bid-row-complement--creation-time"
                        />
                        <ReadonlyField
                            label={t('auctions.bids-list.bid-row.last-modified')}
                            value={bid.lastModTime}
                            className="bid-row-complement--last-mod-time"
                        />
                        {productType.is(SECURITY) && (
                            <ReadonlyField
                                className="bid-row-complement--reference"
                                label={t('auctions.bids-list.bid-row.reference')}
                                value={bid.asBrokerReference || ''}
                            />
                        )}
                    </div>
                </td>
            </tr>
        </>
    );
}

export default AutomaticallyCancelledBidRow;
